import { Injectable } from '@angular/core';

export interface EntityUrlMap {
  [entityName: string]: {
    /**
     * URL relative to the root and tenant.  Does not include leading or trailing slashed.
     */
    entityResourceUrl: string;
    /**
     * URL relative to the root and tenant.  Does not include leading or trailing slashed.
     */
    collectionResourceUrl: string;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CcoEntityUrlRegistryService {
  protected entityUrlMap: EntityUrlMap = {};

  public registerEntityUrls(entityUrlMap: EntityUrlMap): void {
    if (entityUrlMap == null)
      return;

    for (const entityName in entityUrlMap) {
      if (entityName in this.entityUrlMap)
        continue;

      this.entityUrlMap[entityName] = entityUrlMap[entityName];
    }
  }

  public getEntityUrlMap(): EntityUrlMap {
    return { ...this.entityUrlMap };
  }
}
